import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import CheckBox from '@/components/profile/checkBox'
import NumberWithCountry from '@/components/profile/numberWithCountry'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"

import '@/pages/profile/sections/common.css'

export default function WhatsAppNo(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <CheckBox 
                id={props.id}
                text={props.text}
                checked={props.checked}
                onChange={(e: any) => props.handleOnCheckBoxChanged(e, listOfSections.whatsAppNumber)}
            />
            <p className='commonH2'>
                {profile.fields.whatsAppNumber}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            
            <NumberWithCountry 
                countryCodePlaceholder={props.whatsAppCountryCodePlaceholder}
                countryCode={props.whatsAppCountryCode}

                contactNumberPlaceholder={props.whatsAppNumberPlaceholder}
                contactNumber={props.whatsAppNumber}
                
                onChangeCountryCode={(e: any) => props.handleInputChange(e, listOfSections.whatsAppCountryCode)}
                onChangeNumber={(e: any) => props.handleInputChange(e, listOfSections.whatsAppNumber)}

                readOnly={props.checked}
                />


            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.whatsAppNumber)}
                />
            </div>
        </div>
    );
}
